import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';

const clientSlider = () => {
    const galleryThumbs = new Swiper(".swiper-client-nav", {
        modules: [Autoplay],
        slidesPerView: 4, // Show more thumbnails
        spaceBetween: 10,
        freeMode: true,
        autoplay: {
            delay: 3000,
        },
        watchSlidesProgress: true,
        watchOverflow: true,
        slideToClickedSlide: true, // Enables thumbnail click navigation
    });

    const galleryTop = new Swiper(".swiper-client-for", {
        modules: [EffectFade, Autoplay],
        effect: 'fade',
        autoplay: {
            delay: 3000,
        },
        fadeEffect: {
            crossFade: true,
        },
        thumbs: {
            swiper: galleryThumbs,
        },
    });

    // Add active class on click
    galleryThumbs.on('click', function () {
        const clickedIndex = galleryThumbs.clickedIndex;
        if (clickedIndex !== undefined) {
            galleryTop.slideTo(clickedIndex);
            updateActiveClass(clickedIndex);
        }
    });

    // Sync active class when main slider changes
    galleryTop.on('slideChange', function () {
        updateActiveClass(galleryTop.activeIndex);
    });

    function updateActiveClass(activeIndex) {
        document.querySelectorAll(".swiper-client-nav .swiper-slide").forEach((slide, index) => {
            if (index === activeIndex) {
                slide.classList.add("swiper-slide-active");
            } else {
                slide.classList.remove("swiper-slide-active");
            }
        });
    }

    // Ensure first slide has active class on load
    updateActiveClass(0);
};

export { clientSlider as default };
